class MultiMaxLength {
	constructor($timeout) {
		this.$timeout = $timeout;

		this.restrict = 'A';

		this.scope = {
			maxFieldLength: '='
		};

		this.require = 'ngModel';
		this.link = this.MultiMaxLengthLink;
	}

	MultiMaxLengthLink(scope, element, attrs, ctrl) {
		this.$timeout(() => {
			const { maxFieldLength } = attrs;
			const $element = angular.element(element);
			const otherInputsSelector = $element.attr('multi-max-length');
			if (!otherInputsSelector) {
				throw 'multi-max-length must set the name of the field to be compared with.';
			}

			const form = $element.closest('form');
			const $form = angular.element(form);
			const otherInputs = angular.element(`${otherInputsSelector}`, $form);
			const $otherInputs = angular.element(otherInputs);

			const multiMaxLengthValidator = (ngModelValue) => {
				let calculatedLength = $element.val().length;
				$otherInputs.each((i, input) => {
					const $input = angular.element(input);
					const value = $input.val();

					if (value) {
						calculatedLength += value.length;
					}
				});

				const isValid = calculatedLength <= maxFieldLength;
				ctrl.$setValidity('multimaxlength', isValid);

				return isValid;
			};

			ctrl.$parsers.push(multiMaxLengthValidator);
		});
	}
}

export default /* @ngInject */ ($timeout) => new MultiMaxLength($timeout);
